import { render, staticRenderFns } from "./PhoneModel.vue?vue&type=template&id=3964891e&scoped=true"
import script from "./PhoneModel.vue?vue&type=script&lang=js"
export * from "./PhoneModel.vue?vue&type=script&lang=js"
import style0 from "./PhoneModel.vue?vue&type=style&index=0&id=3964891e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3964891e",
  null
  
)

export default component.exports